import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { useMarketOps } from "../MarketOpsContext";
export default function OperationsDesk() {
  const { eligibleAssets } = useMarketOps();
  return <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
    <Typography variant="h6">Operations Desk</Typography>
    <Typography sx={{ my: 2 }}>{eligibleAssets.length} saved operating assets. No live trading status is available.</Typography>
    <Stack direction="row" spacing={1}>
      <Button component={RouterLink} to="/ops/assets">Review onboarding</Button>
      <Button component={RouterLink} to="/optimize">Daily Optimization</Button>
    </Stack>
  </Paper>;
}
